var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cursor-pointer",
      class: {
        "text-secondary": _vm.media.local,
        "text-primary": !_vm.media.local
      },
      on: {
        click: function($event) {
          _vm.$emit("selectMedia", _vm.media)
        }
      }
    },
    [
      _c("q-icon", {
        attrs: { name: _vm.$utils.contentIcon(_vm.media.contentType) }
      }),
      _vm._v("\n  " + _vm._s(_vm.media.name) + "\n  "),
      _vm.media.file_size
        ? _c("small", [
            _vm._v(
              "(" + _vm._s(_vm._f("formatSize")(_vm.media.file_size)) + ")"
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-445c146d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-445c146d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/media-thumb.vue
// module id = null
// module chunks = 